export default __webpack_public_path__ + "static/media/team27.57519f4d.JPG";